// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"people_buttonsContainer__3HEyO","spacer":"people_spacer__1I35k","label":"people_label__3EPPB","search":"people_search__36LXU"};